import { render, staticRenderFns } from "./HistoricPDFTab.vue?vue&type=template&id=5adc38c8&scoped=true&"
import script from "./HistoricPDFTab.vue?vue&type=script&lang=ts&"
export * from "./HistoricPDFTab.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricPDFTab.vue?vue&type=style&index=0&id=5adc38c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc38c8",
  null
  
)

export default component.exports